export enum CourseLevelEnum {
  LEVEL1 = 'LEVEL1',
  LEVEL2 = 'LEVEL2',
  LEVEL3 = 'LEVEL3',
  LEVEL4 = 'LEVEL4',
  LEVEL5 = 'LEVEL5',
}
